import React, { Fragment } from 'react';
import ColorPicker from '../../../Components/ColorPicker';

const ColorSetting = ({ id, label, propKey, fallback, edit, setEdit, themeColorKey, themeColorValue }) => (
  <div className='form-item'>
    <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
      {label}
    </label>
    <ColorPicker
      id={id}
      color={themeColorValue(edit.props, propKey, fallback)}
      setColor={(c) => setEdit(prev => ({
        ...prev,
        props: { ...prev.props, [themeColorKey(propKey)]: c }
      }))}
    />
  </div>
);

const ControlWidgetStyleSettings = ({ edit, setEdit, t, themeColorKey, themeColorValue }) => {
  if (edit.type === 'switch') {
    return (
      <Fragment>
        <ColorSetting
          id="switch-active-color"
          label={t.settingsLabels?.activeColor || 'Active Color'}
          propKey="color"
          fallback="#C52184"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="switch-inactive-color"
          label={t.settingsLabels?.inactiveColor || 'Inactive Color'}
          propKey="inactiveColor"
          fallback="#D1D1D6"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
      </Fragment>
    );
  }

  if (edit.type === 'push-button') {
    return (
      <Fragment>
        <ColorSetting
          id="push-button-active-color"
          label={t.settingsLabels?.activeColor || 'Active Color'}
          propKey="color"
          fallback="#4FC4D3"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="push-button-inactive-color"
          label={t.settingsLabels?.inactiveColor || 'Inactive Color'}
          propKey="inactiveColor"
          fallback="rgba(79, 196, 211, 0.48)"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="push-button-text-color"
          label={t.settingsLabels?.textColor || 'Text Color'}
          propKey="textColor"
          fallback="#FFFFFF"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="push-button-inactive-text-color"
          label={t.settingsLabels?.inactiveTextColor || 'Inactive Text Color'}
          propKey="inactiveTextColor"
          fallback="#8CE7EF"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
      </Fragment>
    );
  }

  if (edit.type === 'segment-switch') {
    return (
      <Fragment>
        <div className='form-item'>
          <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.fontSize || 'Font Size'}
          </label>
          <input
            type='number'
            min='8'
            step='1'
            className='add-column'
            value={edit.props.fontSize ?? 16}
            onBlur={() => {
              if (edit.props.fontSize !== '') return;
              setEdit(prev => ({
                ...prev,
                props: { ...prev.props, fontSize: 16 }
              }));
            }}
            onChange={(e) => {
              const nextValue = e.target.value;
              if (nextValue === '') {
                setEdit(prev => ({
                  ...prev,
                  props: { ...prev.props, fontSize: '' }
                }));
                return;
              }
              const parsed = Number(nextValue);
              if (!Number.isFinite(parsed)) return;
              setEdit(prev => ({
                ...prev,
                props: { ...prev.props, fontSize: Math.max(8, Math.round(parsed)) }
              }));
            }}
          />
        </div>
        <ColorSetting
          id="segment-active-bg-color"
          label={t.settingsLabels?.activeBackgroundColor || 'Active Background Color'}
          propKey="activeBackgroundColor"
          fallback={themeColorValue(edit.props, 'activeOptionColor', 'var(--accent-color)')}
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="segment-active-text-color"
          label={t.settingsLabels?.activeTextColor || 'Active Text Color'}
          propKey="activeTextColor"
          fallback="var(--switch-thumb-color, #ffffff)"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="segment-inactive-bg-color"
          label={t.settingsLabels?.inactiveBackgroundColor || 'Inactive Background Color'}
          propKey="inactiveBackgroundColor"
          fallback="var(--switch-track-unchecked, rgba(29, 41, 61, 0.5))"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
        <ColorSetting
          id="segment-inactive-text-color"
          label={t.settingsLabels?.inactiveTextColor || 'Inactive Text Color'}
          propKey="inactiveTextColor"
          fallback="var(--text-color, #ffffff)"
          edit={edit}
          setEdit={setEdit}
          themeColorKey={themeColorKey}
          themeColorValue={themeColorValue}
        />
      </Fragment>
    );
  }

  return null;
};

export default ControlWidgetStyleSettings;
